import { print, downloadPDF } from "@erp/shared/utils/pdf";
export async function printLaborCost(ref = null, fileName = "") {
    if (!ref) {
        let refLoadCount = 0;
        while (refLoadCount < 50) {
            if (ref) {
                break;
            }
            await new Promise((resolve) => setTimeout(resolve, 100));
            refLoadCount++;
        }
    }
    setTimeout(async () => {
        if (fileName) {
            await downloadPDF(ref, {
                fileName,
                rowCountPerPage: 37,
                mmWidth: 500,
                isLandscape: true,
            });
        }
        else {
            await print(ref, {
                rowCountPerPage: 37,
                mmWidth: 500,
                isLandscape: true,
            });
        }
    }, 500);
}
export function calcRowSpan(labor_cost_data, labor, idx) {
    const labor_data = labor_cost_data;
    let rowspan = 0;
    if (idx > 0 && labor_data[idx].name == labor_data[idx - 1].name) {
        rowspan = 0;
    }
    else {
        labor_data.forEach((data) => {
            if (data.name == labor) {
                rowspan++;
            }
        });
    }
    return rowspan;
}
export function calcNoTotalAmount(labor_cost_data, labor) {
    let sum_no_total_amount = 0;
    labor_cost_data.forEach((data) => {
        if (data.name == labor) {
            sum_no_total_amount += Number(((data.manPerDay || 0) *
                (data.quantity || 0) *
                (data.unitPrice || 0)).toFixed(0));
        }
    });
    return sum_no_total_amount;
}
